import { render, staticRenderFns } from "./WalkIn.vue?vue&type=template&id=3be0d2ca&scoped=true&"
import script from "./WalkIn.vue?vue&type=script&lang=ts&"
export * from "./WalkIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0d2ca",
  null
  
)

export default component.exports